module.exports = __webpack_public_path__ + "static/media/scrum2.a5491242.png";